import styled from "styled-components";
import type { FunctionComponent, ReactNode } from "react";
import { useState } from "react";
import { i18nFilter } from "app/filters/i18nFilter";
import { IconButton } from "@similarweb/ui-components";

interface IAccordionWrapperProps {
    collapseHeight: string;
    expendHeight: string;
    enabled?: boolean;
    onToggle?: (isExpending: boolean) => void;
    collapseButtonKey?: string;
    expendButtonKey?: string;
    children: ReactNode;
}

const ContentContainer = styled.div<{ height: string }>`
    ${({ height }) => `height:${height}`};
    overflow: hidden;
    transition: height 1s;
`;

const CollapseExpendContainer = styled.div`
    position: relative;
`;

const ButtonContainer = styled.div`
    height: 40px;
    background: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.85) 10%);
    justify-content: center;
    display: flex;
    position: absolute;
    bottom: 0px;
    width: 100%;
    .SWReactIcons {
        width: 16px;
        height: 16px;
    }
`;

export const AccordionWrapper: FunctionComponent<IAccordionWrapperProps> = (props) => {
    const {
        collapseHeight,
        expendHeight,
        onToggle,
        children,
        collapseButtonKey = "show less",
        expendButtonKey = "show more",
        enabled = true,
    } = props;
    const [isCollapse, setIsCollapse] = useState<boolean>(true);
    const onCollapseExpend = () => {
        setIsCollapse(!isCollapse);
        onToggle?.(isCollapse);
    };
    if (!enabled) {
        return <>{children}</>;
    }
    return (
        <>
            <ContentContainer height={isCollapse ? collapseHeight : expendHeight}>{children}</ContentContainer>
            <CollapseExpendContainer>
                <ButtonContainer>
                    <IconButton
                        type={"flat"}
                        iconName={"expand"}
                        onClick={onCollapseExpend}
                    >
                        {i18nFilter()(isCollapse ? expendButtonKey : collapseButtonKey)}
                    </IconButton>
                </ButtonContainer>
            </CollapseExpendContainer>
        </>
    );
};
